<template>
  <calm-page extra-class="person" :title="$t('menu.person')">
    <template slot="actions">
      <calm-button variant="primary" icon="plus" @click="handleCreate()">
        {{ $t("new") }}
      </calm-button>
    </template>

    <!-- ═══════════════ SEARCH BAR ═══════════════ -->
    <calm-filter-bar :hide-actions="true">
      <calm-field :label="$t('search')">
        <input
          v-model="searchQuery"
          type="text"
          class="ed"
          :placeholder="$t('search')"
        />
      </calm-field>
    </calm-filter-bar>

    <!-- ═══════════════ TABLE (skin the existing el-table verbatim, §11) ═══════════════ -->
    <calm-table
      :total="total"
      :from="from"
      :to="to"
      :per-page.sync="pagination.perPage"
      :current-page.sync="pagination.currentPage"
      :per-page-options="pagination.perPageOptions"
      :per-page-label="$t('per_page') !== 'per_page' ? $t('per_page') : 'ต่อหน้า'"
      :count-label="$t('data')"
      :to-label="$t('to')"
      :of-label="$t('of')"
      :empty-title="$t('no_data') !== 'no_data' ? $t('no_data') : 'ไม่พบข้อมูล'"
    >
      <el-table
        :data="queriedData"
        row-key="id"
        header-row-class-name="thead-light"
        @sort-change="sortChange"
        @selection-change="selectionChange"
      >
        <el-table-column :label="$t('lmg.code')" min-width="100">
          <template slot-scope="{ row }">
            {{ row.Code }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('lmg.person_type')" min-width="150">
          <template slot-scope="{ row }">
            <span class="person__pill person__pill--type">{{ row.UserType }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('lmg.agent_code')" min-width="120">
          <template slot-scope="{ row }">
            <div class="person__pill person__pill--danger" v-if="row.AdjustCom == true">
            {{ row.AgentCode }}
            </div>
            <div v-if="row.AdjustCom == false">
            {{ row.AgentCode }}
            </div>
          </template>
        </el-table-column>

        <el-table-column :label="$t('name')" min-width="180">
          <template slot-scope="{ row }">
            {{ row.FName }} {{ row.LName }}
          </template>
        </el-table-column>

        <el-table-column
          :label="$t('lmg.with_holding_tax')"
          min-width="100"
        >
          <template slot-scope="{ row }">
            <span class="person__pill person__pill--wht">{{ row.WithholdingTax }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column :label="$t('lmg.taxid')" min-width="150">
          <template slot-scope="{ row }">
            {{ row.TaxID }}
          </template>
        </el-table-column> -->

        <!-- <el-table-column :label="$t('lmg.branch')" min-width="130">
          <template slot-scope="{ row }">
            {{ row.BranchName }}
          </template>
        </el-table-column> -->

        <!-- <el-table-column :label="$t('lmg.address')" min-width="150">
          <template slot-scope="{ row }">
            {{ row.Address }} {{ row.City }} {{ row.Province }}
            {{ row.Postcode }}
          </template>
        </el-table-column> -->

        <!-- <el-table-column :label="$t('status')" min-width="100">
          <template slot-scope="{ row }">
            <div v-if="row.IsActive == 1">{{ $t("status_active") }}</div>
            <div v-else>{{ $t("status_not_active") }}</div>
          </template>
        </el-table-column> -->

        <el-table-column :label="$t('lmg.credit_limit')" min-width="100">
          <template slot-scope="{ row }">
            {{ row.CreditLimit }}
          </template>
        </el-table-column>

        <!-- <el-table-column :label="$t('lmg.person_upper')" min-width="120">
          <template slot-scope="{ row }">
            {{ row.UpperFName }} {{ row.UpperLName }}
          </template>
        </el-table-column> -->

        <el-table-column
          min-width="200px"
          align="right"
          :label="$t('actions')"
        >
          <div slot-scope="{ $index, row }" class="person__rowact">
            <calm-button
              variant="ghost"
              size="sm"
              icon-only
              @click="handleEdit($index, row)"
            >
              <i class="fas fa-pen"></i>
            </calm-button>

            <calm-button
              variant="ghost"
              size="sm"
              @click="handleEditCredit($index, row)"
            >
              <i class="fas fa-pen mr-1"></i>
              {{ $t("lmg.credit") }}
            </calm-button>

            <calm-button
              variant="ghost"
              size="sm"
              @click="handleEditCommission($index, row)"
            >
              <i class="fas fa-pen mr-1"></i>
              {{ $t("menu.comm") }}
            </calm-button>
            <!-- <base-button @click.native="handleDelete($index, row)" class="remove btn-link" type="danger" size="sm"
              icon
            >
              <i class="text-dtac-bt fa fa-trash"></i>
            </base-button> -->
          </div>
        </el-table-column>
      </el-table>
    </calm-table>

    <modal :show.sync="showAddModal" modal-classes="modal-secondary modal-lg" custom-class="calm__dialog calm">
      <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
        <form
          class="person__form"
          @submit.prevent="handleSubmit(onUpdatePerson)"
          v-if="md.Form == 0"
        >
          <h1 v-if="md.Form == 0">{{ $t("menu.person") }}</h1>
          <template v-if="md.Form == 0">
            <div class="person__photo" v-if="image != ''">
              <img :src="image" height="200px" />
            </div>

            <!-- ─────── 1. ข้อมูลทั่วไป / ประเภท (Type / hierarchy) ─────── -->
            <calm-form-section :num="1" :title="$t('lmg.person_type')">
              <div class="calm__form-grid calm__form-grid--3">
                <calm-form-row :label="$t('lmg.person_upper')" v-if="md.ID == 0">
                  <base-input :label="$t('lmg.person_upper')">
                    <el-select
                      class="select-primary pagination-select"
                      v-model="md.UpperID"
                      :placeholder="$t('lmg.person_upper')"
                      popper-class="calm-pop"
                    >
                      <el-option
                        class="select-primary"
                        v-for="item in getPersonUpper"
                        :key="item.ID"
                        :label="item.FName + ' ' + item.LName"
                        :value="item.ID"
                      >
                      </el-option>
                    </el-select>
                  </base-input>
                </calm-form-row>

                <calm-form-row :label="$t('lmg.code')" v-else>
                  <base-input
                    :name="$t('lmg.code')"
                    :label="$t('lmg.code')"
                    :value="md.Code"
                  ></base-input>
                </calm-form-row>

                <calm-form-row :label="$t('lmg.ttype')" required>
                  <base-input
                    :name="$t('lmg.ttype')"
                    :label="$t('lmg.ttype')"
                    rules="required"
                  >
                    <el-select
                      class="select-primary pagination-select"
                      v-model="md.UserTypeID"
                      :placeholder="$t('lmg.ttype')"
                      popper-class="calm-pop"
                    >
                      <el-option
                        class="select-primary"
                        v-for="item in TtypeActive"
                        :key="item.ID"
                        :label="item.Name"
                        :value="item.ID"
                      >
                      </el-option>
                    </el-select>
                  </base-input>
                </calm-form-row>

                <calm-form-row :label="$t('lmg.comm')">
                  <base-input :label="$t('lmg.comm')">
                    <el-select
                      class="select-primary pagination-select"
                      v-model="md.ComprofileID"
                      :placeholder="$t('lmg.comm')"
                      popper-class="calm-pop"
                    >
                      <el-option
                        class="select-primary"
                        v-for="item in tableComm"
                        :key="item.ID"
                        :label="item.Name"
                        :value="item.ID"
                      >
                      </el-option>
                    </el-select>
                  </base-input>
                </calm-form-row>

                <calm-form-row label="รูปภาพ">
                  <span>
                    <div class="form-group">
                      <label class="form-control-label"> รูปภาพ </label>
                      <div class="has-label">
                        <file-input @change="filesChange"></file-input>
                      </div>
                    </div>
                  </span>
                </calm-form-row>
              </div>
            </calm-form-section>

            <!-- ─────── 2. ข้อมูลตัวแทน / ภาษี (Agent / tax) ─────── -->
            <calm-form-section :num="2" :title="$t('lmg.agent_code')">
              <div class="calm__form-grid calm__form-grid--3">
                <calm-form-row :label="$t('lmg.agent_code')" required>
                  <base-input
                    :name="$t('lmg.agent_code')"
                    rules="required"
                    v-model="md.AgentCode"
                  ></base-input>
                </calm-form-row>

                <calm-form-row :label="$t('lmg.taxid')">
                  <base-input
                    :name="$t('lmg.taxid')"
                    rules="digits:13"
                    v-model="md.TaxID"
                  ></base-input>
                </calm-form-row>

                <calm-form-row :label="$t('lmg.with_holding_tax')">
                  <base-input
                    :name="$t('lmg.with_holding_tax')"
                    rules="numeric"
                    v-model="md.WithholdingTax"
                  ></base-input>
                </calm-form-row>
              </div>
            </calm-form-section>

            <!-- ─────── 3. ข้อมูลส่วนตัว (Person) ─────── -->
            <calm-form-section :num="3" :title="$t('name')">
              <div class="calm__form-grid calm__form-grid--3">
                <calm-form-row :label="$t('fname')" required>
                  <base-input
                    :name="$t('fname')"
                    rules="required"
                    v-model="md.FName"
                  ></base-input>
                </calm-form-row>
                <calm-form-row :label="$t('lname')" required>
                  <base-input
                    :name="$t('lname')"
                    rules="required"
                    v-model="md.LName"
                  ></base-input>
                </calm-form-row>
                <calm-form-row :label="$t('birthday')">
                  <base-input :name="$t('birthday')">
                    <flat-picker
                      slot-scope="{ focus, blur }"
                      @on-open="focus"
                      @on-close="blur"
                      :config="{ allowInput: true }"
                      class="form-control datepicker"
                      v-model="md.BirthDay"
                    >
                    </flat-picker>
                  </base-input>
                </calm-form-row>

                <calm-form-row :label="$t('lmg.tel')">
                  <base-input
                    :name="$t('lmg.tel')"
                    v-model="md.Tel"
                  ></base-input>
                </calm-form-row>

                <calm-form-row :label="$t('lmg.email')">
                  <base-input
                    :name="$t('lmg.email')"
                    rules="email"
                    v-model="md.Email"
                  ></base-input>
                </calm-form-row>
              </div>
            </calm-form-section>

            <!-- ─────── 4. ที่อยู่ (Address) ─────── -->
            <calm-form-section :num="4" :title="$t('lmg.address')">
              <div class="calm__form-grid calm__form-grid--3">
                <calm-form-row :label="$t('lmg.address')">
                  <base-input
                    :name="$t('lmg.address')"
                    v-model="md.Address"
                  ></base-input>
                </calm-form-row>
                <calm-form-row :label="$t('lmg.subdistrict')">
                  <base-input
                    :name="$t('lmg.subdistrict')"
                    v-model="md.Subdistrict"
                  ></base-input>
                </calm-form-row>
                <calm-form-row :label="$t('lmg.city')">
                  <base-input
                    :name="$t('lmg.city')"
                    v-model="md.City"
                  ></base-input>
                </calm-form-row>

                <calm-form-row :label="$t('lmg.province')">
                  <base-input
                    :name="$t('lmg.province')"
                    v-model="md.Province"
                  ></base-input>
                </calm-form-row>

                <calm-form-row :label="$t('lmg.postcode')">
                  <base-input
                    :name="$t('lmg.postcode')"
                    rules="digits:5"
                    v-model="md.Postcode"
                  ></base-input>
                </calm-form-row>
              </div>
            </calm-form-section>

            <!-- ─────── 5. เครดิต / สถานะ (Credit / status) ─────── -->
            <calm-form-section :num="5" :title="$t('lmg.credit_limit')">
              <div class="calm__form-grid calm__form-grid--3">
                <calm-form-row :label="$t('lmg.credit_limit')" required v-if="md.ID == 0">
                  <base-input
                    :name="$t('lmg.credit_limit')"
                    v-model="md.CreditLimit"
                    rules="required|numeric"
                  ></base-input>
                </calm-form-row>
                <calm-form-row :label="$t('lmg.credit_range')" required v-if="md.ID == 0">
                  <base-input
                    :name="$t('lmg.credit_range')"
                    rules="required"
                  >
                    <el-select
                      class="select-primary pagination-select"
                      v-model="md.CreditRange"
                      :placeholder="$t('lmg.credit_range')"
                      popper-class="calm-pop"
                    >
                      <el-option
                        class="select-primary"
                        v-for="item in creditRange"
                        :key="item.ID"
                        :label="item.Name"
                        :value="item.ID"
                      >
                      </el-option>
                    </el-select>
                  </base-input>
                </calm-form-row>
                <calm-form-row :label="$t('status')" required v-if="md.ID != 0">
                  <base-input
                    input-classes="form-control-alternative new-event--title"
                    rules="required"
                  >
                    <el-select v-model="md.IsActive" :placeholder="$t('status')" popper-class="calm-pop">
                      <el-option
                        v-for="option in activeStatus"
                        :key="option.ID"
                        :label="option.Name"
                        :value="option.ID"
                      >
                      </el-option>
                    </el-select>
                  </base-input>
                </calm-form-row>
              </div>
            </calm-form-section>
          </template>

          <div class="calm__modal__actions person__actions">
            <calm-button variant="ghost" @click="showAddModal = false">
              {{ $t("close") }}
            </calm-button>
            <calm-button variant="primary" native-type="submit">
              {{ $t("save") }}
            </calm-button>
          </div>
        </form>
      </validation-observer>

      <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
        <form
          class="person__form"
          @submit.prevent="handleSubmit(onUpdateCredit)"
          v-if="md.Form == 1"
        >
          <h1 v-if="md.Form == 1">{{ $t("lmg.change_credit_limit") }}</h1>
          <template v-if="md.Form == 1">
            <calm-form-section :num="1" :title="$t('lmg.bank_name')">
              <div class="calm__form-grid calm__form-grid--2">
                <calm-form-row :label="$t('lmg.bank_name')">
                  <base-input
                    :name="$t('lmg.bank_name')"
                    v-model="md.BankName"
                  ></base-input>
                </calm-form-row>
                <calm-form-row :label="$t('lmg.bank_account')">
                  <base-input
                    :name="$t('lmg.bank_account')"
                    v-model="md.BankAccount"
                  ></base-input>
                </calm-form-row>
              </div>
            </calm-form-section>

            <calm-form-section :num="2" :title="$t('lmg.credit_limit')">
              <div class="calm__form-grid calm__form-grid--3">
                <calm-form-row :label="$t('lmg.credit_limit')" required>
                  <base-input
                    :name="$t('lmg.credit_limit')"
                    rules="required"
                    v-model="md.CreditLimit"
                  ></base-input>
                </calm-form-row>
                <calm-form-row :label="$t('lmg.credit_temp')" required>
                  <base-input
                    :name="$t('lmg.credit_temp')"
                    rules="required"
                    v-model="md.CreditTemp"
                  ></base-input>
                </calm-form-row>
                <calm-form-row :label="$t('lmg.credit_range')" required>
                  <base-input
                    :name="$t('lmg.credit_range')"
                    rules="required"
                  >
                    <el-select
                      class="select-primary pagination-select"
                      v-model="md.CreditRange"
                      :placeholder="$t('lmg.credit_range')"
                      popper-class="calm-pop"
                    >
                      <el-option
                        class="select-primary"
                        v-for="item in creditRange"
                        :key="item.ID"
                        :label="item.Name"
                        :value="item.ID"
                      >
                      </el-option>
                    </el-select>
                  </base-input>
                </calm-form-row>
              </div>
            </calm-form-section>
          </template>

          <input type="hidden" class="new-event--start" />
          <input type="hidden" class="new-event--end" />
          <div class="calm__modal__actions person__actions">
            <calm-button variant="ghost" @click="showAddModal = false">
              {{ $t("close") }}
            </calm-button>
            <calm-button variant="primary" native-type="submit">
              {{ $t("save") }}
            </calm-button>
          </div>
        </form>
      </validation-observer>
    </modal>

    <modal :show.sync="showExtraModal" modal-classes="modal-secondary modal-lg" custom-class="calm__dialog calm">
      <validation-observer v-slot="{ handleSubmit }" ref="fromCommExtra">
        <h1 v-if="md.ComprofileName == ''" class="text-center">
          กรุณาตั้งค่าคอมมิชชั่นโปรไฟล์
        </h1>
        <form
          class="new-event--form"
          @submit.prevent="handleSubmit(onUpdateCommission)"
          v-if="md.ComprofileName != ''"
        >
          <h1>คอมมิชชั่นโปรไฟล์ : {{ md.ComprofileName }}</h1>

          <el-table
            :data="tableCommExtra.Extra"
            row-key="id"
            header-row-class-name="thead-light"
            @sort-change="sortChange"
          >
            <!-- Record paidvia   note bank amount -->
            <el-table-column :label="$t('lmg.insure_type')" min-width="200">
              <template slot-scope="{ row }">
                {{ row.InsuranceShowName }}
              </template>
            </el-table-column>

			<el-table-column :label="$t('lmg.comm_amount') + '(%)'">
              <template slot-scope="{ row }">
                {{ row.Commission }}
              </template>
            </el-table-column>

            <el-table-column :label="$t('lmg.comm_adjust')">
              <template slot-scope="{ row }">
                {{ row.AdjustValue }}
              </template>
            </el-table-column>

            <el-table-column :label="$t('action')">
              <template slot-scope="{ row }">
                <calm-button
                  variant="ghost"
                  size="sm"
                  icon-only
                  @click="handleEditCommExtra(row)"
                >
                  <i class="fas fa-pen"></i>
                </calm-button>
                <!-- pay button -->
              </template>
            </el-table-column>
          </el-table>

          <calm-form-section :num="1" :title="$t('lmg.comm_adjust')">
            <div class="calm__form-grid calm__form-grid--2">
              <calm-form-row class="person__col-span-2" :label="$t('lmg.insure_type')">
                <base-input
                  :name="$t('lmg.insure_type')"
                  :value="md.InsuranceShowName"
                ></base-input>
              </calm-form-row>

              <calm-form-row :label="$t('lmg.comm_adjust') + ' (%)'" required>
                <base-input
                  v-model="md.AdjustValue"
                  :name="$t('lmg.comm_adjust')"
                  rules="required"
                >
                </base-input>
              </calm-form-row>
            </div>
          </calm-form-section>

          <div class="calm__modal__actions person__actions">
            <calm-button variant="ghost" @click="showExtraModal = false">
              {{ $t("close") }}
            </calm-button>
            <calm-button variant="primary" native-type="submit">
              {{ $t("save") }}
            </calm-button>
          </div>
        </form>
      </validation-observer>
    </modal>
  </calm-page>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/PersonPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import FileInput from "@/components/Inputs/FileInput";
export default {
  mixins: [clientPaginationMixin],
  components: {
    FileInput,
    BasePagination,
    RouteBreadCrumb,
    flatPicker,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  computed: {
    ...mapGetters({
      tableDataOrg: "Person/getData",
      tableCommExtra: "Comm/getDataExtra",
      getPersonUpper: "Person/getDataUpper",
      Ttype: "Ttype/getData",
      TtypeActive: "Ttype/getActiveData",
      tableComm: "Comm/getData",
      tableCommWithAll: "Comm/getDataWithAll",
      tableInsureWithAll: "Insure/getDataWithAll"
    }),
    tableData: function() {
      // console.log(this.$route.query.id);
      // if (this.$route.query.id != null) {
      //   return this.tableDataOrg.filter((m) => {
      //     return m.EnterpriseID == "" + this.$route.query.id;
      //   });
      // }

      return this.tableDataOrg;
    }
  },
  data() {
    return {
      propsToSearch: ["Email", "Name"],
      selectedRows: [],
      showAddModal: false,
      showExtraModal: false,
      image: "",
      md: {
        Form: 0,
        Code: "",
        ComprofileName: "",

        ComprofileExtraID: "",
        AdjustValue: 0,
        PersonID: 0,
        InsuranceShowName: "",
        value: "",
        Commission: "",
        LimitCnt: "",
        Insure: "",

        ID: "",
        FName: "",
        LName: "",
        BirthDay: "",
        AgentCode: "",
        WithholdingTax: "",
        TaxID: "",
        Tel: "",
        Email: "",
        Address: "",
        Subdistrict: "",
        City: "",
        Province: "",
        Postcode: "",
        UpperID: "",
        UserTypeID: "",
        IsActive: "",

        CreditLimit: "",
        CreditTemp: "",
        CreditRange: 0,
        BankName: "",
        BankAccount: "",

        File: "",
        ComprofileID: ""
      },
      creditRange: [
        {
          ID: 0,
          Name: "0"
        },
        {
          ID: 1,
          Name: "15"
        },
        {
          ID: 2,
          Name: "30"
        }
      ],
      activeStatus: [
        {
          ID: 1,
          Name: "ใช้งาน"
        },
        {
          ID: 0,
          Name: "ไม่ใช้งาน"
        }
      ]
    };
  },
  async mounted() {
    await this.listData();
    await this.listTtype();
    //  await this.listInsure();
    // await this.listComm();
    this.clearModal();
  },
  methods: {
    ...mapActions({
      createData: "Person/createData",
      updateData: "Person/updateData",
      updateCredit: "Person/updateCredit",
      listExtraDataByPerson: "Comm/listExtraDataByPerson",
      updateExtraDataByPerson: "Comm/updateExtraDataByPerson",
      listData: "Person/listData",
      listTtype: "Ttype/listData",
      getImage: "Person/getImage"
    }),
    clearModal() {
      // if (this.md.ID == 0) return;
      this.md.Form = 0;
      this.md.ComprofileID = "";
      this.md.FName = "";
      this.md.LName = "";
      this.md.BirthDay = "";
      this.md.AgentCode = "";
      this.md.WithholdingTax = "";
      this.md.TaxID = "";
      this.md.Tel = "";
      this.md.Email = "";
      this.md.Address = "";
      this.md.Subdistrict = "";
      this.md.City = "";
      this.md.Province = "";
      this.md.Postcode = "";
      this.md.UserTypeID = this.TtypeActive[0].ID;
      this.md.UpperID = 0;
      this.md.CreditLimit = "";
      this.md.CreditTemp = "";
      this.md.CreditRange = 0;
      this.md.File = "";
      this.md.Code = "";
    },
    handleCreate() {
      this.clearModal();
      this.showAddModal = true;
      this.Form = 0;
      this.md.ID = 0;
    },
    handleEdit(index, row) {
      this.showAddModal = true;
      this.md.Form = 0;
      this.md.ComprofileID = row.ComprofileID;
      this.md.ID = row.ID;
      this.md.FName = row.FName;
      this.md.LName = row.LName;
      this.md.BirthDay = row.BirthDay;
      this.md.AgentCode = row.AgentCode;
      this.md.WithholdingTax = row.WithholdingTax;
      this.md.TaxID = row.TaxID;
      this.md.Tel = row.Tel;
      this.md.Email = row.Email;
      this.md.Address = row.Address;
      this.md.Subdistrict = row.Subdistrict;
      this.md.City = row.City;
      this.md.Province = row.Province;
      this.md.Postcode = row.Postcode;
      this.md.UserTypeID = row.UserTypeID;
      this.md.UpperID = row.UpperID;
      this.md.IsActive = row.IsActive;
      this.md.File = "";
      this.md.Code = row.Code;

      if (this.md.BirthDay == "0000-00-00") {
        this.md.BirthDay = "";
      }

      this.image = "";

      // Get Image
      if (row.Photo != "") {
        this.getImage(row.ID)
          .then(resp => {
            this.image = resp.data;
          })
          .catch(err => {
            this.image = "";
          });
      }
    },
    handleEditCredit(index, row) {
      this.showAddModal = true;
      this.md.Form = 1;
      this.md.ID = row.ID;
      this.md.CreditLimit = row.CreditLimit;
      this.md.CreditTemp = row.CreditTemp;
      this.md.CreditRange = row.CreditRange;

      this.md.BankName = row.BankName;
      this.md.BankAccount = row.BankAccount;
    },
    handleEditCommission(index, row) {
      this.showExtraModal = true;
      this.md.ID = row.ID;
      this.md.ComprofileName = row.ComprofileName;
      this.listExtraDataByPerson(row.ID);
    },
    onUpdateCommission() {
      this.updateExtraDataByPerson({
        comprofileExtraID: this.md.ComprofileExtraID,
        personID: this.md.ID,
        value: this.md.AdjustValue
      })
        .then(resp => {
          this.listExtraDataByPerson(this.md.ID);
          swal.fire({
            title: this.$t("edit_success"),
            text: ``,
            icon: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false
          });
        })
        .catch(err => {
          swal.fire({
            title: this.$t(err.response.data.Msg),
            text: this.getErrorText(err.response.data),
            icon: "error",
            confirmButtonClass: "btn btn-danger btn-fill",
            buttonsStyling: false
          });
        });
    },
    handleEditCommExtra(row) {
      this.md.ComprofileExtraID = row.ID;
      this.md.AdjustValue = row.AdjustValue;
      this.md.PersonID = row.PersonID;
      this.md.InsuranceShowName = row.InsuranceShowName;
    },
    // handleUpdate() {
    //   this.showAddModal = false;

    //   if (this.md.Form == 1) {
    //     // Update Credit ONly
    //     this.updateCredit({
    //       ID: this.md.ID,
    //       credit: this.md.CreditLimit,
    //       creditTemp: this.md.CreditTemp,
    //       creditRange: this.md.CreditRange
    //     })
    //       .then(resp => {
    //         this.listData();
    //         swal.fire({
    //           title: this.$t("edit_success"),
    //           text: ``,
    //           icon: "success",
    //           confirmButtonClass: "btn btn-success btn-fill",
    //           buttonsStyling: false
    //         });
    //       })
    //       .catch(err => {
    //         swal.fire({
    //           title: this.$t(err.response.data.Msg),
    //           text: this.getErrorText(err.response.data),
    //           icon: "error",
    //           confirmButtonClass: "btn btn-danger btn-fill",
    //           buttonsStyling: false
    //         });
    //       });
    //   } else if (this.md.ID == 0) {
    //     // create
    //     this.createData({
    //       typeID: this.md.UserTypeID,
    //       fname: this.md.FName,
    //       lname: this.md.LName,
    //       birthDay: this.md.BirthDay,
    //       agentCode: this.md.AgentCode,
    //       withholdingTax: this.md.WithholdingTax,
    //       taxID: this.md.TaxID,
    //       tel: this.md.Tel,
    //       email: this.md.Email,
    //       address: this.md.Address,
    //       city: this.md.City,
    //       province: this.md.Province,
    //       postcode: this.md.Postcode,
    //       uppderPersonID: this.md.UpperID == "" ? 0 : this.md.UpperID,
    //       creditLimit: this.md.CreditLimit,
    //       creditRange: this.md.CreditRange
    //     })
    //       .then(resp => {
    //         this.listData();
    //         swal.fire({
    //           title: this.$t("create_success"),
    //           text: ``,
    //           icon: "success",
    //           confirmButtonClass: "btn btn-success btn-fill",
    //           buttonsStyling: false
    //         });
    //       })
    //       .catch(err => {
    //         swal.fire({
    //           title: this.$t(err.response.data.Msg),
    //           text: this.getErrorText(err.response.data),
    //           icon: "error",
    //           confirmButtonClass: "btn btn-danger btn-fill",
    //           buttonsStyling: false
    //         });
    //       });
    //   } else {
    //     // update

    //     this.updateData({
    //       ID: this.md.ID,
    //       typeID: this.md.UserTypeID,
    //       fname: this.md.FName,
    //       lname: this.md.LName,
    //       birthDay: this.md.BirthDay,
    //       agentCode: this.md.AgentCode,
    //       withholdingTax: this.md.WithholdingTax,
    //       taxID: this.md.TaxID,
    //       tel: this.md.Tel,
    //       email: this.md.Email,
    //       address: this.md.Address,
    //       city: this.md.City,
    //       province: this.md.Province,
    //       postcode: this.md.Postcode,
    //       uppderPersonID: this.md.UpperID == "" ? 0 : this.md.UpperID,
    //       isActive: this.md.IsActive
    //     })
    //       .then(resp => {
    //         this.listData();
    //         swal.fire({
    //           title: this.$t("edit_success"),
    //           text: ``,
    //           icon: "success",
    //           confirmButtonClass: "btn btn-success btn-fill",
    //           buttonsStyling: false
    //         });
    //       })
    //       .catch(err => {
    //         swal.fire({
    //           title: this.$t(err.response.data.Msg),
    //           text: this.getErrorText(err.response.data),
    //           icon: "error",
    //           confirmButtonClass: "btn btn-danger btn-fill",
    //           buttonsStyling: false
    //         });
    //       });
    //   }
    // },
    onUpdateCredit() {
      this.updateCredit({
        ID: this.md.ID,
        credit: this.md.CreditLimit,
        creditTemp: this.md.CreditTemp,
        creditRange: this.md.CreditRange,
        bankName: this.md.BankName,
        bankAccount: this.md.BankAccount
      })
        .then(resp => {
          this.showAddModal = false;
          this.listData();
          swal.fire({
            title: this.$t("edit_success"),
            text: ``,
            icon: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false
          });
        })
        .catch(err => {
          swal.fire({
            title: this.$t(err.response.data.Msg),
            text: this.getErrorText(err.response.data),
            icon: "error",
            confirmButtonClass: "btn btn-danger btn-fill",
            buttonsStyling: false
          });
        });
    },
    onUpdatePerson() {
      if (this.md.ID == 0) {
        // create

        let formData = new FormData();
        formData.append("typeID", this.md.UserTypeID);
        formData.append("comprofileID", this.md.ComprofileID);
        formData.append("fname", this.md.FName);
        formData.append("lname", this.md.LName);
        formData.append("birthDay", this.md.BirthDay);
        formData.append("agentCode", this.md.AgentCode);
        formData.append("withholdingTax", this.md.WithholdingTax);
        formData.append("taxID", this.md.TaxID);
        formData.append("tel", this.md.Tel);
        formData.append("email", this.md.Email);
        formData.append("address", this.md.Address);
        formData.append("subdistrict", this.md.Subdistrict);
        formData.append("city", this.md.City);
        formData.append("province", this.md.Province);
        formData.append("postcode", this.md.Postcode);
        formData.append(
          "uppderPersonID",
          this.md.UpperID == "" ? 0 : this.md.UpperID
        );
        formData.append("creditLimit", this.md.CreditLimit);
        formData.append("creditRange", this.md.CreditRange);
        formData.append("photo", this.md.File);

        this.createData(formData)
          .then(resp => {
            this.showAddModal = false;
            this.listData();
            swal.fire({
              title: this.$t("create_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            });
          })
          .catch(err => {
            swal.fire({
              title: this.$t(err.response.data.Msg),
              text: this.getErrorText(err.response.data),
              icon: "error",
              confirmButtonClass: "btn btn-danger btn-fill",
              buttonsStyling: false
            });
          });
      } else {
        // update

        if (this.md.BirthDay == "") {
          this.md.BirthDay = "0000-00-00";
        }

        let formData = new FormData();
        formData.append("ID", this.md.ID);
        formData.append("comprofileID", this.md.ComprofileID);
        formData.append("typeID", this.md.UserTypeID);
        formData.append("fname", this.md.FName);
        formData.append("lname", this.md.LName);
        formData.append("birthDay", this.md.BirthDay);
        formData.append("agentCode", this.md.AgentCode);
        formData.append("withholdingTax", this.md.WithholdingTax);
        formData.append("taxID", this.md.TaxID);
        formData.append("tel", this.md.Tel);
        formData.append("email", this.md.Email);
        formData.append("address", this.md.Address);
        formData.append("subdistrict", this.md.Subdistrict);
        formData.append("city", this.md.City);
        formData.append("province", this.md.Province);
        formData.append("postcode", this.md.Postcode);
        formData.append(
          "uppderPersonID",
          this.md.UpperID == "" ? 0 : this.md.UpperID
        );
        formData.append("isActive", this.md.IsActive);
        formData.append("photo", this.md.File);

        this.updateData(formData)
          .then(resp => {
            this.listData();
            this.showAddModal = false;
            swal.fire({
              title: this.$t("edit_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            });
          })
          .catch(err => {
            swal.fire({
              title: this.$t(err.response.data.Msg),
              text: this.getErrorText(err.response.data),
              icon: "error",
              confirmButtonClass: "btn btn-danger btn-fill",
              buttonsStyling: false
            });
          });
      }
    },
    handleDelete(index, row) {
      swal
        .fire({
          title: this.$t("delete_confirm"),
          text: this.$t("delete_confirm_question") + row.Name,
          icon: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.deleteData({
              id: row.ID
            })
              .then(resp => {
                this.listData();
                swal.fire({
                  title: this.$t("delete_success"),
                  text: ``,
                  icon: "success",
                  confirmButtonClass: "btn btn-success btn-fill",
                  buttonsStyling: false
                });
              })
              .catch(err => {
                swal.fire({
                  title: this.$t(err.response.data.Msg),
                  text: this.getErrorText(err.response.data),
                  icon: "error",
                  confirmButtonClass: "btn btn-danger btn-fill",
                  buttonsStyling: false
                });
              });
          }
        });
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
    filesChange(files) {
      this.md.File = files[0];
    }
  }
};
</script>
<style scoped>
/* Person (sales-force / agent master) — Calm skin. Everything namespaced
   under .person so nothing leaks to other pages. The el-table is kept verbatim
   (§11 "skin, don't rewrite") and re-styled only through deep selectors below.
   The 3 modals stay on the existing Argon <modal> (custom-class="calm__dialog
   calm") — the SAFE path for the heavy multipart form, so the photo upload +
   image preview + FormData submit mechanics are untouched; fields are merely
   re-laid-out via calm-form-section + calm-form-row. */

/* Row-action cell: keep the icon/labelled buttons inline + right-aligned. */
.person__rowact {
  display: inline-flex;
  gap: 6px;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
}

/* Presentation pills (status only — no logic change). */
.person__pill {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 13px;
  line-height: 1.4;
}
.person__pill--type {
  background: var(--c-blue-soft, #ebf2fa);
  color: var(--c-blue-deep, #2c5282);
}
.person__pill--wht {
  background: var(--c-surface-soft, #f4f7fb);
  color: var(--c-text-soft, #5b6b7e);
}
/* Preserve the legacy red flag for AdjustCom agents. */
.person__pill--danger {
  background: var(--c-danger-soft, #fdecec);
  color: var(--c-danger, #d6336c);
  font-weight: 600;
}

/* The free-text search box reuses the Kit's .ed input look. */
.person >>> .ed {
  width: 100%;
}

/* Photo preview block at the top of the person modal. */
.person__photo {
  margin-bottom: 16px;
}

/* Grid spans for fields that should occupy more than one column. */
.person__col-span-2 { grid-column: span 2; }
@media (max-width: 720px) {
  .person__col-span-2 { grid-column: span 1; }
}

/* Action row pinned to the bottom of each modal body. */
.person__actions { margin-top: 20px; }

/* Drop the base-input's own bottom margin — calm-form-row owns the spacing. */
.person__form >>> .form-group {
  margin-bottom: 0;
}
/* base-input renders its own <label>; we use calm-form-row's label instead,
   so hide the inner one to avoid a doubled label (the file-input's own
   "รูปภาพ" label is left visible since it has no calm-form-row dup). */
.person__form >>> .calm__form-row .form-group > label {
  display: none;
}
/* Let the slotted el-select fill the row width. */
.person__form >>> .el-select {
  width: 100%;
}

/* Skin the existing <el-table> so it reads as a Calm surface without touching
   any column definitions or slots (§11). Deep selectors only. Covers both the
   page list table and the commission-extra table inside the modal. */
.person >>> .el-table {
  color: var(--c-text, #2c3e50);
  background: transparent;
}
.person >>> .el-table th,
.person >>> .el-table .thead-light th {
  background: var(--c-surface-soft, #f4f7fb);
  color: var(--c-text-soft, #5b6b7e);
  font-weight: 600;
  border-bottom: 1px solid var(--c-border, #e3e9f0);
}
.person >>> .el-table td {
  border-bottom: 1px solid var(--c-border, #eef2f7);
}
.person >>> .el-table::before {
  background: var(--c-border, #e3e9f0);
}
.person >>> .el-table__row:hover > td {
  background: var(--c-surface-soft, #f7fafd) !important;
}
</style>
